import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {DataService} from '../services/data.service';
import {RestService} from '../services/rest.service';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit, OnDestroy {
    username = '';
    name = '';
    email = '';
    language = 'ro';
    currentPassword = '';
    newPassword = '';
    newPasswordConfirmation = '';
    isSaving = false;
    successMessage = '';
    errorMessage = '';
    private sessionSubscription: Subscription;

    constructor(
        private dataService: DataService,
        private restService: RestService
    ) {
    }

    ngOnInit() {
        this.applyUserInfo(this.dataService.getUserInfo());
        this.sessionSubscription = this.dataService.dataChangedSession.subscribe(() => {
            this.applyUserInfo(this.dataService.getUserInfo());
        });
    }

    ngOnDestroy() {
        if (this.sessionSubscription) {
            this.sessionSubscription.unsubscribe();
        }
    }

    saveProfile(form: NgForm) {
        this.successMessage = '';
        this.errorMessage = '';

        if (form.invalid || this.name.trim() === '' || this.email.trim() === '') {
            this.errorMessage = 'Enter a name and a valid email address.';
            return;
        }

        const wantsPasswordChange = this.currentPassword !== ''
            || this.newPassword !== ''
            || this.newPasswordConfirmation !== '';

        if (wantsPasswordChange
            && (this.currentPassword === ''
                || this.newPassword === ''
                || this.newPasswordConfirmation === '')) {
            this.errorMessage = 'Complete all three password fields to change your password.';
            return;
        }

        if (wantsPasswordChange && this.newPassword !== this.newPasswordConfirmation) {
            this.errorMessage = 'The new passwords do not match.';
            return;
        }

        this.isSaving = true;
        this.restService.updateAdminProfile({
            Name: this.name.trim(),
            Email: this.email.trim(),
            Language: this.language,
            CurrentPassword: this.currentPassword,
            NewPassword: this.newPassword,
            NewPasswordConfirmation: this.newPasswordConfirmation
        }).pipe(
            finalize(() => {
                this.isSaving = false;
            })
        ).subscribe((response: any) => {
            if (!this.dataService.isResponseSuccessful(response) || !response.UserInfo) {
                this.errorMessage = response && response.StatusMessage
                    ? response.StatusMessage
                    : 'The profile could not be updated.';
                return;
            }

            this.currentPassword = '';
            this.newPassword = '';
            this.newPasswordConfirmation = '';
            this.applyUserInfo(response.UserInfo);
            this.dataService.setUserInfo(response.UserInfo);
            this.successMessage = response.StatusMessage || 'Profile updated successfully.';
        }, (error: any) => {
            this.errorMessage = error && error.error && error.error.StatusMessage
                ? error.error.StatusMessage
                : 'The profile could not be updated.';
        });
    }

    private applyUserInfo(userInfo: any) {
        if (!userInfo) {
            return;
        }

        this.username = userInfo.Username || '';
        this.name = userInfo.Name || '';
        this.email = userInfo.Email || '';
        this.language = userInfo.Language === 'en' ? 'en' : 'ro';
    }
}
